<template>
  <div class="homes">
    <!-- 模块导航 -->
    <div class="column1box">
      <div class="containerHome">
        <ul class="navCon">
          <li
            v-for="(item, index) in activityList"
            :key="index"
            @mouseenter="(e) => addHoverClass(item)"
            @mouseleave="(e) => removeHoverClass(item)"
            @click="toMore(item.value)"
            :class="{ 'hover-active': item.isHover }"
          >
            <img class="bg" :src="item.bgImgUrl" alt="" />
            <p class="hover" v-if="item.isHover"></p>
            <div class="con">
              <img
                class="icon"
                :src="
                  item.isHover
                    ? item.checkIcon
                      ? item.checkIcon
                      : item.imgUrl
                    : item.imgUrl
                "
                alt=""
              />
              <p class="title">{{ item.title }}</p>
              <p class="subtitle">{{ item.subtitle }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- 通知公告 -->
    <div class="column2box">
      <div class="containerHome">
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <div class="contentBox whithBg policy">
              <div class="topHeader">
                <div>通知公告</div>
                <div @click="toMore(1)">更多>></div>
              </div>
              <div class="botContent">
                <div
                  class="contItem"
                  v-for="(item, i) in noticeList1"
                  :key="i"
                  @click="toDetail(item)"
                >
                  <div class="left_content">
                    <div></div>
                    <div>
                      {{ item.title }}
                    </div>
                  </div>
                  <div class="right_content">{{ item.releaseTime }}</div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <div class="contentBox whithBg policy">
              <div class="topHeader">
                <div>行业动态</div>
                <div @click="toMore(2)">更多>></div>
              </div>
              <div class="botContent">
                <div
                  class="contItem"
                  v-for="(item, i) in noticeList2"
                  :key="i"
                  @click="toDetail(item)"
                >
                  <div class="left_content">
                    <div></div>
                    <div>
                      {{ item.title }}
                    </div>
                  </div>
                  <div class="right_content">{{ item.releaseTime }}</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import { getList } from "@/api/desk/notice";
import { dateFormat } from "@/utils/date";
export default {
  name: "Home",
  data() {
    return {
      isHover: false,
      noticeList1: [],
      noticeList2: [],
      activityList: [
        {
          imgUrl: require("@/assets/images/home/nav1.png"),
          checkIcon: require("@/assets/images/home/tr1.png"),
          bgImgUrl: require("@/assets/images/home/bj1.png"),
          title: "资源库",
          subtitle: "RESOURCE LIBRARY",
          isHover: false,
          value: "zyk",
        },
        {
          imgUrl: require("@/assets/images/home/nav2.png"),
          bgImgUrl: require("@/assets/images/home/bj2.png"),
          title: "海外办学",
          subtitle: "OVERSEAS EDUCATION",
          isHover: false,
          value: "overseasEducation",
        },
        {
          imgUrl: require("@/assets/images/home/nav3.png"),
          bgImgUrl: require("@/assets/images/home/bj3.png"),
          title: "国际交流",
          subtitle: "INTERNATIONAL EXCHANGE",
          isHover: false,
          value: "internationalExchange",
        },
        {
          imgUrl: require("@/assets/images/home/nav4.png"),
          bgImgUrl: require("@/assets/images/home/bj4.png"),
          title: "人才培养",
          subtitle: "PERSONNEL TRAINING",
          isHover: false,
          value: "personnelTraining",
        },
        {
          imgUrl: require("@/assets/images/home/nav5.png"),
          bgImgUrl: require("@/assets/images/home/bj5.png"),
          title: "产教融合",
          subtitle: "INTEGRATION OF INDUSTRY AND EDUCATION",
          isHover: false,
          value: "childbirthEducation",
        },
        {
          imgUrl: require("@/assets/images/home/nav6.png"),
          bgImgUrl: require("@/assets/images/home/bj6.png"),
          title: "校企合作",
          subtitle: "SCHOOL ENTERPRISE COOPERATION",
          isHover: false,
          value: "schoolEnterprise",
        },
        {
          imgUrl: require("@/assets/images/home/nav7.png"),
          checkIcon: require("@/assets/images/home/tr7.png"),
          bgImgUrl: require("@/assets/images/home/bj7.png"),
          title: "留学服务",
          subtitle: "STUDY ABROAD SERVICES",
          isHover: false,
          value: "studyAbroad",
        },
        {
          imgUrl: require("@/assets/images/home/nav8.png"),
          bgImgUrl: require("@/assets/images/home/bj8.png"),
          title: "需求信息",
          subtitle: "DEMAND INFORMATION",
          isHover: false,
          value: "demandInformation",
        },
        {
          imgUrl: require("@/assets/images/home/nav9.png"),
          bgImgUrl: require("@/assets/images/home/bj9.png"),
          title: "共建单位",
          subtitle: "CO CONSTRUCTION UNIT",
          isHover: false,
          value: "unit",
        },
        {
          imgUrl: require("@/assets/images/home/nav10.png"),
          checkIcon: require("@/assets/images/home/tr10.png"),
          bgImgUrl: require("@/assets/images/home/bj10.png"),
          title: "服务组织",
          subtitle: "SERVICE ORGANIZATION",
          isHover: false,
          value: "serviceOrganization",
        },
        {
          imgUrl: require("@/assets/images/home/nav11.png"),
          bgImgUrl: require("@/assets/images/home/bj11.png"),
          title: "政策文件",
          subtitle: "POLICY DOCUMENT",
          isHover: false,
          value: "zcwj",
        },
        {
          imgUrl: require("@/assets/images/home/nav12.png"),
          checkIcon: require("@/assets/images/home/tr12.png"),
          bgImgUrl: require("@/assets/images/home/bj12.png"),
          title: "项目信息",
          subtitle: "PROJECT INFORMATION",
          isHover: false,
          value: "xmxx",
        },
      ],
    };
  },
  mounted() {
    if (this.$route.path == "/index") {
      this.getList(1);
      this.getList(2);
    }
  },
  methods: {
    addHoverClass(item) {
      this.$set(item, "isHover", true);
    },
    removeHoverClass(item) {
      this.$set(item, "isHover", false);
    },
    getList(category) {
      getList(1, 7, { category: category }).then((res) => {
        const data = res.data;
        data.records.map((item) => {
          item.releaseTime = dateFormat(
            new Date(item.releaseTime),
            "yyyy-MM-dd"
          );
        });
        this[`noticeList${category}`] = data.records;
      });
    },
    toDetail(item) {
      if (item.isOutsideChain == 2) {
        if (item.url) window.open(item.url);
      } else {
        this.$router.push({
          path: "/details",
          query: { id: item.id, category: item.category },
        });
      }
    },
    toMore(category) {
      if (category == "xmxx") {
        window.open("https://www.yidaiyilu.gov.cn/project");
        return;
      }
      if (category == "zcwj") {
        window.open("https://www.yidaiyilu.gov.cn/policy");
        return;
      }
      if (category == "zyk") {
        return;
      }

      this.$router.push({
        path: "/moreDetail",
        query: { category: category },
      });
    },
  },
};
</script>
<style scoped lang="less">
.homes {
  p,
  ul,
  li,
  h1,
  h2 {
    margin: 0;
    padding: 0;
  }
  .column1box {
    padding: 70px 0;
    @media (max-width: 768px) {
      padding: 40px 0;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      li {
        margin-right: 20px;
        margin-bottom: 20px;
        width: calc(25% - 15px);
        height: 195px;
        @media (min-width: 768px) and (max-width: 1200px) {
          width: calc((100% / 3) - calc(40px / 3));
        }
        @media (max-width: 768px) {
          width: calc((100% / 3) - 10px);
          height: 160px;
          margin-right: 15px;
          margin-bottom: 15px;
        }
        position: relative;
        background: #fff;
        .bg {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          object-fit: fill;
          opacity: 0.4;
        }
        .con {
          width: 100%;
          padding: 25px 30px;
          @media (min-width: 768px) and (max-width: 1200px) {
            padding: 20px 25px;
          }
          @media (max-width: 768px) {
            padding: 12px;
          }

          box-sizing: border-box;
          position: absolute;
          z-index: 10;
          top: 0;
          left: 0;
          .title {
            font-size: 20px;
            @media (min-width: 768px) and (max-width: 1200px) {
              font-size: 18px;
            }
            @media (max-width: 768px) {
              font-size: 15px;
            }

            font-weight: bold;
            color: #4a4a4a;
          }
          .subtitle {
            font-size: 12px;
            margin-top: 10px;
            line-height: 24px;
            @media (max-width: 768px) {
              font-size: 8px;
              margin-top: 5px;
              line-height: 20px;
            }
            color: #848080;
          }
          img.icon {
            width: 46px;
            @media (min-width: 768px) and (max-width: 1200px) {
              width: 40px;
            }
            @media (max-width: 768px) {
              width: 36px;
            }
            margin-bottom: 15px;
          }
        }
        @media (min-width: 1200px) {
          &:nth-child(4n) {
            margin-right: 0px;
          }
          &:nth-child(n + 8) {
            margin-bottom: 0px;
          }
        }

        @media (min-width: 768px) and (max-width: 1200px) {
          &:nth-child(3n) {
            margin-right: 0px;
          }
          &:nth-child(n + 10) {
            margin-bottom: 0px;
          }
        }
        @media (max-width: 768px) {
          &:nth-child(3n) {
            margin-right: 0px;
          }
          &:nth-child(n + 10) {
            margin-bottom: 0px;
          }
        }

        .hover {
          display: none;
          position: absolute;
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 5;
        }
        &.hover-active {
          .hover {
            background: #0387fa !important;
            display: block;
            opacity: 0.8;
          }

          .title {
            color: #fff;
          }
          .subtitle {
            color: #fff;
          }
        }
      }
    }
  }
  .column2box {
    background: #fff;
    padding-bottom: 80px;
  }
  .contentBox {
    margin-top: 50px;
  }

  .whithBg {
    background: #fff;
    padding: 5px 20px;
    box-sizing: border-box;

    .topHeader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #dcdfdc;
      div {
        padding: 10px 0;
        box-sizing: border-box;
        font-size: 20px;
        @media (min-width: 768px) and (max-width: 1200px) {
          font-size: 18px;
        }
        @media (max-width: 768px) {
          font-size: 16px;
        }
      }

      div:first-child {
        font-weight: 700;
        border-bottom: 2px solid #015293;
      }

      div:nth-child(2) {
        font-size: 12px;
        color: #848283;
        cursor: pointer;
      }
    }
  }
  // 政策法规
  .policy {
    max-height: 310px;
    .contItem {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      margin-top: 16px;

      .left_content {
        display: flex;
        justify-content: center;
        align-items: center;
        width: calc(100% - 85px);
        div:first-child {
          width: 6px;
          height: 6px;
          border-radius: 1px;
          background: #3c6fa2;
        }

        div:nth-child(2) {
          font-size: 16px;
          @media (min-width: 768px) and (max-width: 1200px) {
            font-size: 15px;
          }
          @media (max-width: 768px) {
            font-size: 14px;
          }
          margin: 0 16px;
          width: calc(100% - 32px);
          overflow: hidden;
          word-break: break-all;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
      }

      .right_content {
        width: 85px;
        font-size: 12px;
        color: #8f8f8f;
        text-align: right;
      }
    }

    .contItem:hover .left_content div:nth-child(2) {
      color: #015293;
    }
  }
}
</style>